// Uma fila com vagas: no máximo N tarefas rodando ao mesmo tempo.
//
// Existe para a tela de Domínios conferir o DNS de TODAS as linhas ao abrir.
// Cada conferência são umas dez consultas de DNS feitas pela API, e disparar
// as cinquenta linhas de uma página de uma vez jogaria quinhentas consultas
// nos resolvedores públicos no mesmo segundo. De quatro em quatro, a página
// inteira enche em poucos segundos, e o servidor nem percebe.

export function criarVez(vagas: number) {
  let ocupadas = 0;
  const esperando: (() => void)[] = [];

  return async function naVez<T>(tarefa: () => Promise<T>, sinal?: AbortSignal): Promise<T> {
    if (ocupadas < vagas) {
      ocupadas++;
    } else {
      // A vaga chega TRANSFERIDA de quem terminou, sem passar pelo
      // contador. Se ele baixasse e subisse de novo, quem chegasse entre as
      // duas coisas furaria a fila e passaria do limite.
      await new Promise<void>((entrar) => esperando.push(entrar));
    }
    try {
      // Quem desistiu enquanto esperava (trocou de página, fechou a tela)
      // não gasta a vaga com uma consulta que ninguém vai olhar.
      if (sinal?.aborted) throw new DOMException("desistiu na fila", "AbortError");
      return await tarefa();
    } finally {
      const proximo = esperando.shift();
      if (proximo) proximo();
      else ocupadas--;
    }
  };
}
